import { pushToDataLayer } from '../dataLayer'
import {
  AnalyticsFormMode,
  AnalyticsProductCharacteristicsField,
  AnalyticsProductPackageField,
  AnalyticsProductPriceField,
  AnalyticsProductRegulatoryInformationField,
} from './types'

const ProductTitleValidationError = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'dados-basicos: titulo-da-oferta',
  })
}

const ProductCharacteristicsValidationError = (
  formMode: AnalyticsFormMode,
  productField: AnalyticsProductCharacteristicsField
): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: `caracteristicas: ${productField}`,
  })
}

const ProductRegulatoryInformationValidationError = (
  formMode: AnalyticsFormMode,
  productField: AnalyticsProductRegulatoryInformationField
): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller: produtos: ${formMode}`,
    content_id: `dados-basicos: informacoes-regulatorias: ${productField}`,
  })
}

const ProductAnatelCertificationValidationError = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller: produtos: ${formMode}`,
    content_id: 'content_id: dados-basicos: certificacao-e-registro-anatel',
  })
}

const ProductVariationAttributeValidationError = (
  formMode: AnalyticsFormMode,
  variationAttributeName: string
): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller: produtos: ${formMode}`,
    content_id: `dados-basicos: variacoes-do-produto: ${variationAttributeName}`,
  })
}

const ProductImageUploadError = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller: produtos: ${formMode}`,
    content_id: 'variacoes-do-produto:erro-no-upload-de-imagens',
  })
}

const ProductVideoUploadError = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: variacoes-do-produto: ${formMode}`,
    content_id: 'video-adicionado',
  })
}

const ProductDatasheetValidationError = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'ficha-tecnica:ficha-tecnica',
  })
}

const ProductPackageValidationError = (
  formMode: AnalyticsFormMode,
  productField: AnalyticsProductPackageField
): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: `dados-de-envio:peso-dimensões-do-produto-embalado: ${productField}`,
  })
}

const ProductPriceValidationError = (
  formMode: AnalyticsFormMode,
  productField: AnalyticsProductPriceField
): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: `publicacao:preco: ${productField}`,
  })
}

const ProductStockValidationError = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'publicacao:estoque: estoque',
  })
}

const ProductDescriptionValidationError = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_error',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'publicacao:descreva-o-produto',
  })
}

export {
  ProductTitleValidationError,
  ProductCharacteristicsValidationError,
  ProductRegulatoryInformationValidationError,
  ProductAnatelCertificationValidationError,
  ProductVariationAttributeValidationError,
  ProductImageUploadError,
  ProductVideoUploadError,
  ProductDatasheetValidationError,
  ProductPackageValidationError,
  ProductPriceValidationError,
  ProductStockValidationError,
  ProductDescriptionValidationError,
}
